module.exports = __webpack_public_path__ + "static/media/1.9cb9cbdc.png";